import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { unsubscribe } from '../api/subscribers';

type State = 'loading' | 'success' | 'error';

export default function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState<State>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setState('error');
      setMessage('Invalid unsubscribe link — the token is missing.');
      return;
    }
    unsubscribe(token)
      .then((res) => {
        setState('success');
        setMessage(res.message);
      })
      .catch((err: Error) => {
        setState('error');
        setMessage(err.message ?? 'Invalid or expired unsubscribe link.');
      });
  }, [searchParams]);

  // The API returns a distinct message when the address was already
  // unsubscribed — surface it instead of always showing the first-time copy.
  const alreadyUnsubscribed = state === 'success' && message.toLowerCase().includes('already');

  return (
    <div style={{ maxWidth: 480, margin: '48px auto', padding: '0 16px', textAlign: 'center' }}>
      {state === 'loading' && (
        <>
          <h1>Unsubscribing…</h1>
          <p style={{ color: 'var(--text-muted)' }}>Please wait.</p>
        </>
      )}
      {state === 'success' && (
        <>
          <h1>{alreadyUnsubscribed ? 'Already unsubscribed' : 'Unsubscribed'}</h1>
          <p style={{ color: 'var(--text-primary)' }}>
            {alreadyUnsubscribed
              ? 'This email was already unsubscribed — no further action is needed.'
              : 'You have been unsubscribed from SkyMap API documentation updates.'}
          </p>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>
            Changed your mind?{' '}
            <a href="/subscribe" style={{ color: 'var(--accent-text)' }}>
              Subscribe again
            </a>
            .
          </p>
        </>
      )}
      {state === 'error' && (
        <>
          <h1 style={{ color: 'var(--danger-text)' }}>Unsubscribe failed</h1>
          <p style={{ color: 'var(--text-primary)' }}>{message}</p>
        </>
      )}
    </div>
  );
}
